export default "__VITE_ASSET__B15liDVF__"